import { useTranslation } from "react-i18next";
import { getMessageStatusFilterValue, messageStatusLabelKey } from "./messageStatus";

export default function MessageStatusBadge({ status }) {
    const { t } = useTranslation();
    const value = getMessageStatusFilterValue(status);
    const labelKey = messageStatusLabelKey(status);

    if (!value || !labelKey) {
        return <span className="message-status-badge is-empty">—</span>;
    }

    return (
        <span className={`message-status-badge is-${value}`}>
            <span className="message-status-badge__dot" aria-hidden="true" />
            {t(labelKey)}
        </span>
    );
}
